import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Players from './pages/Players';
import ModuleSelect from './pages/ModuleSelect';
import Game from './pages/Game';
import { usePlayers } from './hooks/usePlayers';
import { usePurchases } from './hooks/usePurchases';
import type { GameMode } from './hooks/useGameLogic';
import './index.css';

function App() {
  const {
    players,
    addPlayer,
    removePlayer,
    canAddMore,
    hasEnoughPlayers,
  } = usePlayers();

  const {
    isModulePurchased,
    purchaseModule,
    restorePurchases,
  } = usePurchases();

  const [selectedMode, setSelectedMode] = useState<GameMode>('soft');

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<Home isModulePurchased={isModulePurchased} />}
        />
        <Route
          path="/players"
          element={
            <Players
              players={players}
              onAddPlayer={addPlayer}
              onRemovePlayer={removePlayer}
              canAddMore={canAddMore}
              hasEnoughPlayers={hasEnoughPlayers}
            />
          }
        />
        <Route
          path="/select"
          element={
            hasEnoughPlayers ? (
              <ModuleSelect
                onSelectMode={setSelectedMode}
                isModulePurchased={isModulePurchased}
                onPurchase={purchaseModule}
                onRestore={restorePurchases}
              />
            ) : (
              <Navigate to="/players" replace />
            )
          }
        />
        <Route
          path="/game"
          element={
            hasEnoughPlayers ? (
              <Game mode={selectedMode} players={players} />
            ) : (
              <Navigate to="/players" replace />
            )
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
